<template>
  <div class="header-message">
    <div class="header-message__body">
      <slot />
    </div>
    <span
      v-if="canBeClosed"
      class="shape-cross"
      @click="closeMessage" />
  </div>
</template>

<script>
export default {
  name: 'HeaderMessage',

  props: {
    canBeClosed: {
      type: Boolean,
      default: true,
    },
  },

  methods: {
    closeMessage() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
  .header-message {
    padding: 10px 5%;
    font-size: $text-13px;
    line-height: 1.38;
    font-weight: 400;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: $color--basic-blue;
    z-index: 2;
  }

  .shape-cross {
    margin-left: 16px;
    width: 14px;
    height: 14px;
    flex-shrink: 0;
  }
</style>
